import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { FaTimes } from "react-icons/fa";
import InputField from "../../SharedComponent/Fields/InputField";
import TextareaField from "../../SharedComponent/Fields/TextareaField";
import Button from "../../SharedComponent/Button/Button";
import { getProtected, patchProtected } from "../../network/ApiService";
import { API_END_POINTS } from "../../network/apiEndPoint";
import { toast } from "react-toastify";
import Loading from "../../SharedComponent/Loading";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const EditFinanceAssetPage = (props) => {
  const { show, onClose, asset } = props;
  const { t } = useTranslation();
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [allFinance , setAllFinance] = useState([]) ;
   const [searchParams, setSearchParams] = useSearchParams();
   const navigate = useNavigate() ; 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((pre) => ({ ...pre, [name]: value }));
  };

  useEffect(() => {
    setValues({ ...show });
  }, [show]);

  useEffect(() => {
    console.log("params = " , searchParams.get('assetId') ) ;
    const id = searchParams.get('financeId')
     const getAllFinance = async () => {
        setAllFinance([]);
        try {
          if (!id) return;
          const url = `${API_END_POINTS.financeReport}${id}`;
          const response = await getProtected(url);
          if (response) {
            setAllFinance(response);
            console.log("response = " ,response)  ; 
          }
        } catch (e) {
          console.log("error = " , e) ; 
        
        }
      };
      getAllFinance() ; 
  } , [] )

  const handleCreateAsset = async (e) => {
    console.log("called")
    const assetId = searchParams.get('assetId')
    const financeId = searchParams.get('financeId')

    try {
      setLoading(true);
      const payload = {...values};
      console.log(payload)

      const url = `${API_END_POINTS.financeReport}${assetId}/${financeId}/`;
      const response = await patchProtected(url, payload);
      if (response) {
        setValues({});
        // onClose(false);
        setLoading(false);
        toast.success(t('finance.update.success'));
        navigate('/dashboard')
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
      const message = e?.response?.data?.messages;
      if (message && message?.[0]?.message) {
        toast.error(message[0].message);
      } else {
        toast.error(t('finance.update.error'));
      }
    } finally {
      setLoading(false);
    }
  };

//   if (!show) return null;
  return (
    <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6 md:p-8 relative">
      <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-800">{t('finance.update.title')}</h2>
      
      <button
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
        onClick={() => onClose(false)}
        aria-label={t('common.close')}
      >
        <FaTimes />
      </button>
      
      <Loading loading={loading} />
      
      <div className="mt-4">
        <div className="space-y-4">
          <InputField
            type="date"
            name="date"
            value={values.date}
            onChange={handleChange}
            required
            label={t('finance.create.fields.date')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.date')}`}
          />
          
          <InputField
            type="number"
            name="depreciation"
            value={values.depreciation}
            onChange={handleChange}
            required
            label={t('finance.create.fields.depreciation')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.depreciation')}`}
          />
          
          <InputField
            type="number"
            name="insurance_costs"
            value={values.insurance_costs}
            onChange={handleChange}
            required
            label={t('finance.create.fields.insuranceCosts')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.insuranceCosts')}`}
          />
          
          <InputField
            type="number"
            name="maintenance_costs"
            value={values.maintenance_costs}
            onChange={handleChange}
            required
            label={t('finance.create.fields.maintenanceCosts')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.maintenanceCosts')}`}
          />
          
          <InputField
            type="number"
            name="operating_costs"
            value={values.operating_costs}
            onChange={handleChange}
            required
            label={t('finance.create.fields.operatingCosts')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.operatingCosts')}`}
          />
          
          <TextareaField
            name="notes"
            value={values.notes}
            onChange={handleChange}
            required
            label={t('finance.create.fields.notes')}
            placeholder={`${t('finance.create.placeholders.enter')} ${t('finance.create.fields.notes')}`}
          />
        </div>
        
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-end">
          <Button variant="close" >
            {t('finance.create.buttons.cancel')}
          </Button>
          <Button type="button" onClick={handleCreateAsset}>
            {t('finance.update.buttons.update')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditFinanceAssetPage;
